export const getPortfolios_ForBacktesting = `
query getPortfolios_ForBacktesting( $owner : String! ) {
  listPortfoliosByOwner(owner: $owner, sortDirection: DESC) {
    items {
      id
      name
      shareEntries {
        items {
          count
        }
      }
      etfEntries {
        items {
          count
        }
      }
    }
  }
}
`
